'use client'

import { useReferralLink } from '@/features/referral/use-referral-link'
import { SettingsSection } from '../../settings-section'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Copy, Gift } from 'lucide-react'

export const ReferralTab = () => {
    const { referralLink, copyReferralLink, isGenerating } = useReferralLink()

    return (
        <div className="flex flex-col gap-8">
            <SettingsSection
                title="Refer a Friend"
                description="Share your referral link with friends. When they start a paid subscription, you'll earn 3,000 credits!"
            >
                {referralLink ? (
                    <div className="flex items-end gap-3">
                        <div className="flex-1 max-w-md">
                            <Input value={referralLink} readOnly className="font-mono text-sm" />
                        </div>
                        <Button
                            variant="primary"
                            size="sm"
                            onClick={() => copyReferralLink('settings')}
                            className="gap-2"
                        >
                            <Copy className="w-4 h-4" />
                            Copy Link
                        </Button>
                    </div>
                ) : (
                    <div className="flex items-center gap-4 rounded-xl border border-[#E5E7EB] bg-[#FAFAFA] p-4">
                        <div className="flex h-10 w-10 items-center justify-center rounded-full bg-blue-50 shrink-0">
                            <Gift className="h-5 w-5 text-blue-600" />
                        </div>
                        <div className="flex-1">
                            <p className="text-[14px] font-medium text-[#171717]">Get your referral link</p>
                            <p className="text-[13px] text-[#6B7280]">
                                Generate a unique referral link to start earning credits.
                            </p>
                        </div>
                        <Button
                            variant="primary"
                            size="sm"
                            onClick={() => copyReferralLink('settings')}
                            isLoading={isGenerating}
                            className="gap-2"
                        >
                            <Gift className="w-4 h-4" />
                            Generate & Copy Link
                        </Button>
                    </div>
                )}
            </SettingsSection>

            <SettingsSection title="How it works">
                <div className="flex flex-col gap-3">
                    <div className="flex items-start gap-3">
                        <div className="flex h-6 w-6 items-center justify-center rounded-full bg-[#F3F4F6] text-[12px] font-semibold text-[#6B7280] shrink-0">
                            1
                        </div>
                        <p className="text-[14px] text-[#374151]">Share your unique referral link with a friend</p>
                    </div>
                    <div className="flex items-start gap-3">
                        <div className="flex h-6 w-6 items-center justify-center rounded-full bg-[#F3F4F6] text-[12px] font-semibold text-[#6B7280] shrink-0">
                            2
                        </div>
                        <p className="text-[14px] text-[#374151]">
                            They sign up using your link and start a paid subscription
                        </p>
                    </div>
                    <div className="flex items-start gap-3">
                        <div className="flex h-6 w-6 items-center justify-center rounded-full bg-[#F3F4F6] text-[12px] font-semibold text-[#6B7280] shrink-0">
                            3
                        </div>
                        <p className="text-[14px] text-[#374151]">You receive 3,000 bonus credits automatically</p>
                    </div>
                </div>
            </SettingsSection>
        </div>
    )
}
